// extracted by mini-css-extract-plugin
export default {"loadingImage":"AuthImage_loadingImage__xHjEX"};